<template>
  <div class="search-list tw:overflow-auto tw:scrollbar-none">
    <TextPlay v-if="items.length === 0" class="tw:p-4">
      Nenhum resultado encontrado
    </TextPlay>
    <template v-for="item in items" :key="item.id">
      <SearchItem :item="item" @click="$emit('item-click', item)" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import SearchItem from '@/components/common/SearchItem/SearchItem.vue'

defineProps<{
  items: unknown[]
}>()

defineEmits<{
  'item-click': [item: unknown]
}>()
</script>
